<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.2229 23.76C9.87429 23.76 8.78286 23.4171 6.88571 22.0457C5.68571 23.5886 1.88571 24.7943 1.72 22.7314C1.72 21.1829 1.37714 19.8743 0.988571 18.4457C0.525714 16.6857 0 14.7257 0 11.8857C0 5.10286 5.56571 0 12.16 0C18.76 0 23.9314 5.35429 23.9314 11.9486C23.9421 15.0666 22.7152 18.0615 20.52 20.2759C18.3249 22.4903 15.3409 23.7434 12.2229 23.76ZM12.32 5.86286C9.10857 5.69714 6.60571 7.92 6.05143 11.4057C5.59429 14.2914 6.40571 17.8057 7.09714 17.9886C7.42857 18.0686 8.26286 17.3943 8.78286 16.8743C9.6427 17.4683 10.644 17.825 11.6857 17.9086C13.2853 17.9855 14.8512 17.4318 16.0469 16.3665C17.2426 15.3012 17.9726 13.8093 18.08 12.2114C18.1425 10.6103 17.574 9.0486 16.4968 7.86238C15.4196 6.67615 13.9197 5.9602 12.32 5.86857V5.86286Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts" setup>
  defineProps({
    color: {
      type: String,
      default: "rgb(49, 118, 255)",
    },
  });
</script>
